/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const FIELD_IS_VALID = 'FIELD_IS_VALID';
export const fieldIsValid = (field) => ({
  type: FIELD_IS_VALID,
  field
});

export const FIELD_IS_INVALID = 'FIELD_IS_INVALID';
export const fieldIsInvalid = (field, reason = true) => ({
  type: FIELD_IS_INVALID,
  field,
  reason
});

export const CONTACT_INFO_SAVED = 'CONTACT_INFO_SAVED';
export const contactInfoWasSaved = (wasSaved) => ({
  type: CONTACT_INFO_SAVED,
  wasSaved
});

export const TOUCHED_FIELD = 'TOUCHED_FIELD';
export const touchedField = (field) => ({
  type: TOUCHED_FIELD,
  field
});

export const CLEAR_INVALID_FIELDS = 'CLEAR_INVALID_FIELDS';
export const clearInvalidFields = () => ({
  type: CLEAR_INVALID_FIELDS
});

export const CLEAR_TOUCHED_FIELDS = 'CLEAR_TOUCHED_FIELDS';
export const clearTouchedFields = () => ({
  type: CLEAR_TOUCHED_FIELDS
});

export const REQUESTED_ADDRESS_VALIDATION = 'REQUESTED_ADDRESS_VALIDATION';
export const requestedAddressValidation = () => ({
  type: REQUESTED_ADDRESS_VALIDATION
});

export const RECEIVED_ADDRESS_VALIDATION = 'RECEIVED_ADDRESS_VALIDATION';
export const receivedAddressValidation = (address) => ({
  type: RECEIVED_ADDRESS_VALIDATION,
  address
});

export const ERROR_ADDRESS_VALIDATION = 'ERROR_ADDRESS_VALIDATION';
export const errorAddressValidation = (error) => ({
  type: ERROR_ADDRESS_VALIDATION,
  error
});
